module.exports = ({"version":"v3.240.1","revision":"dd006be859798b88048817aa832d4594ca0afdc8","applicationMode":"prod","environmentMode":"saas"})